module.exports = __webpack_public_path__ + "static/img/cl.53ca595c.svg";